<template>
  <div>
    <div class="container_buttons">
      <button class="btn-search" @click="showConfigModal">Adicionar plano do gerenet</button>
      <div class="form-group container_filter">
        <label for="exampleFormControlTextarea2">Filtrar Planos</label>
        <select class="form-control input" @change="onChangeStatus" v-model="groupId" required>
          <option value="all" selected>Todos</option>
          <option value="27">Internet</option>
          <option value="29">TV</option>
          <option value="30">Telefone</option>
        </select>
      </div>
    </div>
    <card title="Mostruario de Planos" subTitle="Planos mostrados no site">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID do Plano Gerenet</th>
            <th>Nome</th>
            <th>Velocidade</th>
            <th>Recomendado?</th>
            <th>Mostrar no site</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="plan in plans" :key="plan.planId">
              <td>{{ plan.planId }}</td>
              <td>{{ plan.name }}</td>
              <td>{{ plan.speed }}</td>
              <td>{{ plan.recommended ? "Sim" : "Não" }}</td>
              <td>{{ plan.internal ? "Não" : "Sim" }}</td>
              <td>
                <p-button
                  v-if="!plan.recommended"
                  type="success"
                  outline
                  icon
                  title="Recomendar Plano"
                  @click.prevent.native="recommend(plan.id)"
                >
                  <i class="fa fa-check-circle"></i>
                </p-button>
                <p-button
                  v-else
                  type="success"
                  outline
                  icon
                  title="Remover Recomendado"
                  @click.prevent.native="unrecommend(plan.id)"
                >
                  <i class="fa fa-times"></i>
                </p-button>
                <p-button
                  v-if="!plan.internal"
                  type="primary"
                  outline
                  icon
                  title="Ocultar plano do site"
                  @click.prevent.native="internalize(plan.id)"
                >
                  <i class="fa fa-check-circle"></i>
                </p-button>
                <p-button
                  v-else
                  type="primary"
                  outline
                  icon
                  title="Mostrar plano no site"
                  @click.prevent.native="externalize(plan.id)"
                >
                  <i class="fa fa-times"></i>
                </p-button>
                <p-button
                  type="danger"
                  outline
                  icon
                  title="Apagar Plano"
                  @click.prevent.native="deleteRow(plan.id)"
                >
                  <i class="fa fa-ban btn-delete"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <modal name="config" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">Descrições do plano selecionado</p>
      <hr />
      <form class="container" @submit.prevent="createPlan">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              label="ID do plano gerenet"
              required
              min="1"
              step="1"
              v-model="planId"
              placeholder="Digite o id do plano gerenet..."
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              label="Texto 1"
              required
              placeholder="Digite a descrição 1..."
              v-model="planDescriptions[0]"
            ></fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              label="Texto 2"
              required
              placeholder="Digite a descrição 2..."
              v-model="planDescriptions[1]"
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              label="Texto 3"
              required
              placeholder="Digite a descrição 3..."
              v-model="planDescriptions[2]"
            ></fg-input>
          </div>
        </div>
        <button class="btn-add-modal">Adicionar</button>
        <div class="clearfix"></div>
      </form>
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  computed: {
    plans() {
      return this.$store.getters.plans;
    },
  },
  data() {
    return {
      planId: "",
      planDescriptions: [],
      groupId: 'all',
    };
  },
  methods: {
    showConfigModal() {
      this.$modal.show("config");
    },
    ...mapActions(["fetchPlans", "addPlan", "updatePlan", "deletePlan"]),
    async createPlan() {
      if (!this.planId) {
        return;
      }
      try {
        await this.addPlan({id: parseInt(this.planId), descriptions: this.planDescriptions.filter(Boolean)});
        Swal.fire({
          title: "Sucesso!",
          text: "Plano adicionado com sucesso",
          icon: "success",
        });
      } catch (e) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível adicionar o plano",
          icon: "error",
        });
      }
    },
    async onChangeStatus(e) {
      this.groupId = e.target.value;
      await this.fetchPlans({
        groupId: e.target.value !== 'all' ? e.target.value : undefined,
      });
    },
    async recommend(id) {
      try {
        await this.updatePlan({ id, recommended: true });
        Swal.fire({
          title: "Sucesso!",
          text: "Plano atualizado com sucesso",
          icon: "success",
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar o plano",
          icon: "error",
        });
      }
    },
    async unrecommend(id) {
      try {
        await this.updatePlan({ id, recommended: false });
        Swal.fire({
          title: "Sucesso!",
          text: "Plano atualizado com sucesso",
          icon: "success",
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar o plano",
          icon: "error",
        });
      }
    },
    async internalize(id) {
      try {
        await this.updatePlan({ id, internal: true });
        Swal.fire({
          title: "Sucesso!",
          text: "Plano atualizado com sucesso",
          icon: "success",
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar o plano",
          icon: "error",
        });
      }
    },
    async externalize(id) {
      try {
        await this.updatePlan({ id, internal: false });
        Swal.fire({
          title: "Sucesso!",
          text: "Plano atualizado com sucesso",
          icon: "success",
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar o plano",
          icon: "error",
        });
      }
    },
    async internalize(id) {
      try {
        await this.updatePlan({ id, internal: true });
        Swal.fire({
          title: "Sucesso!",
          text: "Plano atualizado com sucesso",
          icon: "success",
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar o plano",
          icon: "error",
        });
      }
    },
    async externalize(id) {
      try {
        await this.updatePlan({ id, internal: false });
        Swal.fire({
          title: "Sucesso!",
          text: "Plano atualizado com sucesso",
          icon: "success",
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar o plano",
          icon: "error",
        });
      }
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text: "Esta ação irá remover o plano do mostruário, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      });

      if (result.isConfirmed) {
        try {
          await this.deletePlan({ id });
          Swal.fire({
            title: "Sucesso!",
            text: "Plano removido com sucesso",
            icon: "success",
          });
        } catch (e) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível remover o plano",
            icon: "error",
          });
        }
      }
    },
  },
  async mounted() {
    try {
      await this.fetchPlans();
    } catch (err) {
      Swal.fire({
        title: "Ops!",
        text: "Não foi possível carregar os planos",
        icon: "error",
      });
    }
  },
};
</script>

<style scoped>
.container_buttons {
  display: flex;
  justify-content: space-between;
}
.container_filter select {
  width: 15vw;
}
input {
  padding: 5px;
  width: 15vw;
}
button.btn-add-modal {
  padding: 8px 30px;
  background-color: #9dcf6b;
  border: 1px solid #000;
  margin-top: 10px;
  font-weight: bold;
}

.modal-title {
  font-weight: bold;
  color: #000;
}
button.btn-search {
  border-radius: 5px;
  height: 50px;
  width: auto;
  padding: 10px 50px;
  font-weight: bold;
  font-size: 15px;
  border: none;
  border: 1px solid;
  background: #9dcf6b;
}
</style>
